import React from 'react';
import SVGTheCulinistas from '../../svg/TheCulinistas';
import ENV_CONFIG from '../../env';

const NavAdminMenu = () => {
  return (
    <div className="nav__logo">
      <a
        href={`//${ENV_CONFIG.REACT_APP_WWW_HOST}/`}
        className="brand the-culinistas"
      >
        <SVGTheCulinistas />
      </a>
    </div>
  );
};

export default NavAdminMenu;



// WEBPACK FOOTER //
// ./src/components/nav/NavLogo.js